import React from 'react'
import { ContactsTable } from 'components/Tables/ContactsTable/ContactsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from '../CompanyModal'

interface ContactsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function ContactsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: ContactsModalProps) {
  const TABLE_KEY = `contacts-modal-${contactCompany.id}-${forDoorProxyId || 'company'}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Contacts"
    >
      <ContactsTable
        defaultColumnVisibility={{
          requested_contact__campaign__name: false,
        }}
        tableKey={TABLE_KEY}
        forCompany={contactCompany}
        forDoorProxyId={forDoorProxyId}
        disableUrlPagination
        disableExportButton
      />
    </CompanyModal>
  )
}
